<script type="application/javascript">
export default {
    data() {
        return {
            selectedProductCategory: null,
            selectedSolutionsCategory: null,
            productCategories: [
                {
                    name: 'Features',
                    items: [
                        {
                            link: '/features#Views',
                            icon: '/img/features/Views-icon-p.svg',
                            name: 'Views',
                            description: '8 Different Ways to View Your Data',
                            subitems: [
                                {
                                    link: '/features#Table',
                                    icon: 'fa-table',
                                    name: 'Table',
                                    description: 'Display items in a spreadsheet. Great for CRM and databases.'
                                },
                                {
                                    link: '/features#Columns',
                                    icon: 'fa-chart-kanban',
                                    name: 'Columns',
                                    description: 'Kanban board, ideal to visually track your tasks and projects.'
                                },
                                {
                                    link: '/features#List',
                                    icon: 'fa-list',
                                    name: 'List',
                                    description: 'Simplified list view, perfect for notes, to-do lists and ideas.'
                                },
                                {
                                    link: '/features#Calendar',
                                    icon: 'fa-calendar-days',
                                    name: 'Calendar',
                                    description: 'View items in a calendar. Perfect for event planning and scheduling.'
                                },
                                {
                                    link: '/features#Gantt',
                                    icon: 'fa-chart-gantt',
                                    name: 'Gantt',
                                    description: 'Manage your work on a timeline. Great for project tracking.'
                                },
                                {
                                    link: '/features#Form',
                                    icon: 'fa-form',
                                    name: 'Form',
                                    description: 'Create custom forms for surveys and feedback collection.'
                                },
                                {
                                    link: '/features#Document-View',
                                    icon: 'fa-document',
                                    name: 'Document View',
                                    description: 'Create and edit important documents for what you are working on right here in Infinity.'
                                },
                                {
                                    link: '/features#Gallery-View',
                                    icon: 'fa-gallery',
                                    name: 'Gallery View',
                                    description: 'Preview any images or attachments you add to Infinity in the best way possible.'
                                }
                            ]
                        },
                        {
                            link: '/features#Attributes',
                            icon: '/img/features/Attributes-icon-p.svg',
                            name: 'Attributes',
                            description: '20 Custom Attributes to Add to Your Items',
                            subitems: [
                                {
                                    link: '/features#Date',
                                    icon: 'fa-calendar-days',
                                    name: 'Date',
                                    description: 'Add date and time fields in different formats to items.'
                                },
                                {
                                    link: '/features#Labels',
                                    icon: 'fa-tags',
                                    name: 'Labels',
                                    description: 'Create and add fully customizable sets of tags to tasks.'
                                },
                                {
                                    link: '/features#Checkbox',
                                    icon: 'fa-square-check',
                                    name: 'Checkbox',
                                    description: 'Use a checkbox in your items to mark a task complete.'
                                },
                                {
                                    link: '/features#Text',
                                    icon: 'fa-pen-line',
                                    name: 'Text',
                                    description: 'Name your tasks or add a single line of text to them.'
                                },
                                {
                                    link: '/features#Long-Text',
                                    icon: 'fa-memo-pad',
                                    name: 'Long Text',
                                    description: 'Write descriptions and instructions in rich text format.'
                                },
                                {
                                    link: '/features#Checklist',
                                    icon: '',
                                    name: 'Checklist',
                                    description: 'Add subtasks to items and tick them off when done.'
                                },
                                {
                                    link: '/features#Links',
                                    icon: '',
                                    name: 'Links',
                                    description: 'Add links to important documents and files to items.'
                                },
                                {
                                    link: '/features#Attachments',
                                    icon: '',
                                    name: 'Attachments',
                                    description: 'Upload files or images from your computer to tasks.'
                                },
                                {
                                    link: '/features#Number',
                                    icon: '',
                                    name: 'Number',
                                    description: 'Add percentage, decimals, and currencies to items.'
                                },
                                {
                                    link: '/features#Reference',
                                    icon: '',
                                    name: 'Reference',
                                    description: 'Link different items to each other across the board.'
                                },
                                {
                                    link: '/features#Members',
                                    icon: '',
                                    name: 'Members',
                                    description: 'Assign your team members to their tasks in Infinity.'
                                },
                                {
                                    link: '/features#Progress',
                                    icon: '',
                                    name: 'Progress',
                                    description: 'Add a progress bar to tasks to keep track of them.'
                                },
                                {
                                    link: '/features#Rating',
                                    icon: '',
                                    name: 'Rating',
                                    description: 'Rate the importance of your tasks from one to ten.'
                                },
                                {
                                    link: '/features#Email',
                                    icon: '',
                                    name: 'Email',
                                    description: 'Add relevant email addresses to your items in Infinity.'
                                },
                                {
                                    link: '/features#Phone',
                                    icon: '',
                                    name: 'Phone',
                                    description: 'Note down important phone numbers in your items.'
                                },
                                {
                                    link: '/features#Created-At',
                                    icon: '',
                                    name: 'Created At',
                                    description: 'Include the date and time of task creation with ease.'
                                },
                                {
                                    link: '/features#Created-By',
                                    icon: '',
                                    name: 'Created By',
                                    description: 'Add the creator of the task automatically to your items.'
                                },
                                {
                                    link: '/features#Vote',
                                    icon: '',
                                    name: 'Vote',
                                    description: 'Create an "Upvote" or "Vote" option, and allow collaborators to add unique votes per item.'
                                },
                                {
                                    link: '/features#Formulas',
                                    icon: '',
                                    name: 'Formulas',
                                    description: 'Use simple and advanced formulas for calculations between numeric fields in your tables.'
                                }
                            ]
                        },
                        {
                            link: '/features#Customization',
                            icon: '/img/features/Customization-icon-p.svg',
                            name: 'Customization',
                            description: 'Multiple Options to Customize Your Data',
                            subitems: [
                                {
                                    link: '/features#Filter',
                                    icon: 'fa-filters',
                                    name: 'Filter',
                                    description: 'Create your own formulas to filter out and view only certain items.'
                                },
                                {
                                    link: '/features#Group',
                                    icon: 'fa-diagram-cells',
                                    name: 'Group',
                                    description: 'Group your data into columns or separate lists.'
                                },
                                {
                                    link: '/features#Sort',
                                    icon: 'fa-sort',
                                    name: 'Sort',
                                    description: 'Sort your data by any attribute you have.'
                                },
                                {
                                    link: '/features#Reorder',
                                    icon: 'fa-arrow-down-arrow-up',
                                    name: 'Reorder',
                                    description: 'Modify the look of your items by reordering the details on them.'
                                },
                                {
                                    link: '/features#Dark mode',
                                    icon: 'fa-moon',
                                    name: 'Dark Mode',
                                    description: 'Use Summarize to perform basic calculations in your tables.'
                                },
                                {
                                    link: '/features#Show-Hide',
                                    icon: '',
                                    name: 'Show / Hide',
                                    description: 'Customize your views fully by hiding or showing attributes.'
                                },
                                {
                                    link: '/features#Colors',
                                    icon: '',
                                    name: 'Colors',
                                    description: 'Use different colors to better customize your boards and labels.'
                                },
                                {
                                    link: '/features#Change-View',
                                    icon: '',
                                    name: 'Change View',
                                    description: 'Choose to see your items in Table, Column, List, Calendar, or Gantt view.'
                                }
                            ]
                        },
                        {
                            link: '/features#Structure',
                            icon: '/img/features/Structure-icon-p.svg',
                            name: 'Structure',
                            description: 'Endless Possibilities to Organize Your Work',
                            subitems: [
                                {
                                    link: '/features#Workspace',
                                    icon: 'fa-briefcase',
                                    name: 'Workspace',
                                    description: 'Workspace is the starting point of your organization. It can be used for one company/brand.'
                                },
                                {
                                    link: '/features#Boards',
                                    icon: 'fa-border-all',
                                    name: 'Boards',
                                    description: 'Boards are the main sections of your workspace. Use them for departments, projects, clients, etc.'
                                },
                                {
                                    link: '/features#Folders',
                                    icon: 'fa-folders',
                                    name: 'Folders',
                                    description: 'Folders will help you classify your data within a board. Use them to store more data without creating clutter.'
                                },
                                {
                                    link: '/features#Subfolders',
                                    icon: 'fa-folder-tree',
                                    name: 'Subfolders',
                                    description: 'With Infinity’s nesting structure you can create unlimited subfolders to subdivide your folder data if you need to.'
                                },
                                {
                                    link: '/features#Tabs',
                                    icon: 'fa-diagram-next',
                                    name: 'Tabs',
                                    description: 'Tabs will help you see your folder data in different ways. Use them to highlight certain data or get a different preview.'
                                },
                                {
                                    link: '/features#Item',
                                    icon: '',
                                    name: 'Item',
                                    description: 'Item is the core unit of Infinity and it can be anything - a task, lead, idea, note, contact, experiment, etc.'
                                }
                            ]
                        },
                        {
                            link: '/features#Collaboration',
                            icon: '/img/features/Collaboration-icon-p.svg',
                            name: 'Collaboration',
                            description: 'Different Ways for Your Team to Collaborate',
                            subitems: [
                                {
                                    link: '/features#Invite',
                                    icon: 'fa-user-plus',
                                    name: 'Invite',
                                    description: 'Invite people to join your team and collaborate with you.'
                                },
                                {
                                    link: '/features#Comment',
                                    icon: 'fa-comment',
                                    name: 'Comment',
                                    description: 'Use comments to communicate with your team members.'
                                },
                                {
                                    link: '/features#Share-Board',
                                    icon: 'fa-globe-pointer',
                                    name: 'Share Board',
                                    description: 'Make one of your boards public and share it with people outside Infinity.'
                                },
                                {
                                    link: '/features#Permissions',
                                    icon: 'fa-lock-keyhole',
                                    name: 'Permissions',
                                    description: 'Set up your team’s permissions - on the role level but also for individual users.'
                                },
                                {
                                    link: '/features#Offline Mode',
                                    icon: 'fa-cloud-slash',
                                    name: 'Offline Mode',
                                    description: 'Set up your team’s permissions - on the role level but also for individual users.'
                                },
                                {
                                    link: '/features#Mention',
                                    icon: '',
                                    name: 'Mention',
                                    description: 'Mention people in comments and they will immediately receive a notification.'
                                },
                                {
                                    link: '/features#Assign',
                                    icon: '',
                                    name: 'Assign',
                                    description: 'Assign tasks to one or multiple users to define the team’s responsibilities.'
                                },
                                {
                                    link: '/features#Activity-Log',
                                    icon: '',
                                    name: 'Activity Log',
                                    description: 'Activity log helps you track all changes that happen on the board and item level.'
                                },
                                {
                                    link: '/features#Notifications',
                                    icon: '',
                                    name: 'Notifications',
                                    description: 'Email and in-app notifications will alert your team when there’s an important update.'
                                },
                                {
                                    link: '/features#Print',
                                    icon: '',
                                    name: 'Print',
                                    description: 'Save your documents, lists, and tables in paper form with Infinity’s print option.'
                                },
                                {
                                    link: '/features#2FA',
                                    icon: '',
                                    name: '2FA',
                                    description: 'Make sure your data is protected from unauthorized access with two-factor authentication.'
                                },
                                {
                                    link: '/features#Reports',
                                    icon: '',
                                    name: 'Reports',
                                    description: 'Keep up with what your team is up to by creating reports on a weekly or monthly basis.'
                                },
                                {
                                    link: '/features#Keyboard-Shortcuts',
                                    icon: '',
                                    name: 'Keyboard Shortcuts',
                                    description: 'Use your keyboard to efficiently navigate your boards, and create and complete new tasks.'
                                }
                            ]
                        },
                        {
                            link: '/features#Automations',
                            icon: '/img/features/Automations-icon-p.svg',
                            name: 'Automations',
                            description: 'Automate Your Workflows',
                            subitems: [
                                {
                                    link: '/features#Recurring-Tasks',
                                    icon: 'fa-rotate-right',
                                    name: 'Recurring Tasks',
                                    description: 'Manage repeat dates and create schedules for your tasks with Infinity’s recurring tasks.'
                                },
                                {
                                    link: '/features#Reminders',
                                    icon: 'fa-bell',
                                    name: 'Reminders',
                                    description: 'Set reminders for all of your tasks and make sure your team never forget about them.'
                                },
                                {
                                    link: '/features#IFTTT Rules',
                                    icon: 'fa-brackets-curly',
                                    name: 'IFTTT Rules',
                                    description: 'Automate all of your workflows with ease and improve your business processes.'
                                },
                                {
                                    link: '/features#Form Submitted',
                                    icon: 'fa-comments-question-check',
                                    name: 'Form Submitted',
                                    description: 'Automate all of your workflows with ease and improve your business processes.'
                                }
                            ]
                        }
                    ]
                },
                {
                    name: 'Integrations',
                    items: [
                        {
                            link: '/api',
                            icon: '/img/infinity-icon.png',
                            name: 'Infinity API',
                            description: 'Improve your workflows and automate routine work by connecting Infinity to your favorite third-party apps.'
                        },
                        {
                            link: '/integrations/zapier',
                            icon: '/img/features/icons/zapier.svg',
                            name: 'Zapier',
                            description: 'Connect Infinity with over 3,000 different apps with our Zapier integration.'
                        },
                        {
                            link: '/integrations/clockify',
                            icon: 'https://startinfinity.s3.us-east-2.amazonaws.com/production/integrations/integration/2/Qm7x3uOyyYjCor99wVxlQPrE8FXP5fa0GkK6cikP.png',
                            name: 'Clockify',
                            description: 'Use our Clockify integration to easily track the time you spend on your tasks.'
                        },
                        {
                            link: '/integrations/trello-import',
                            icon: 'https://startinfinity.s3.us-east-2.amazonaws.com/production/integrations/integration/3/hfs3NCKA1sNaBmr0VSwG4kjCwFkJPPCkFbX4KUQB.png',
                            name: 'Trello Import',
                            description: 'Use the Trello import to easily move projects to Infinity and continue working.'
                        },
                        {
                            link: '/integrations/csv-import',
                            icon: 'https://startinfinity.s3.us-east-2.amazonaws.com/production/integrations/integration/4/JSroxEZlghb84dgevfc3pwP5JfDYUFUkapYya3uK.png',
                            name: 'CSV Import',
                            description: 'Import or export CSV files from Infinity with ease, for the ultimate work organization.'
                        },
                        {
                            link: '/integrations/integrately',
                            icon: 'https://startinfinity.s3.us-east-2.amazonaws.com/production/integrations/integration/5/2TBIKxT7uf76jnIbQ7z3fhmXh69yDcYYWsV58o0m.png',
                            name: 'Integrately',
                            description: 'Connect Infinity to all the apps you use on a daily basis in just one click.'
                        },
                        {
                            link: '/integrations/pabbly-connect',
                            icon: 'https://startinfinity.s3.us-east-2.amazonaws.com/production/integrations/integration/6/MtrVOPF8iE8UrWLLG69fTnzGeHIIWBclKJBqfdb3.png',
                            name: 'Pabbly Connect',
                            description: 'Use Pabbly Connect to quickly integrate your favorite software and Infinity.'
                        },
                        {
                            link: '/integrations/google-drive-integration',
                            icon: 'https://startinfinity.s3.us-east-2.amazonaws.com/production/integrations/integration/8/Ob52gmw6MzClRI2N73nzXj3bEIe0qhBTMmoGnQdW.png',
                            name: 'Google Drive',
                            description: 'Connect Infinity to your Google Drive and upload all important files in a few easy steps.'
                        },
                        {
                            link: '/integrations/icalendar-integration',
                            icon: 'https://startinfinity.s3.us-east-2.amazonaws.com/production/integrations/integration/9/lkGJyQntEMWcB6wxOckJ7as6xKLrcmNXvg15O9ch.png',
                            name: 'iCalendar',
                            description: 'Sync Infinity with other calendar tools you use daily with our iCalendar integration.'
                        },
                        {
                            link: '/integrations/google-calendar-integration',
                            icon: 'https://startinfinity.s3.us-east-2.amazonaws.com/production/integrations/integration/10/CjK37TzDj2InMl8AuozRnwRU42CaybQgmbWruRor.png',
                            name: 'Google Calendar',
                            description: 'Integrate Infinity with your Google Calendar and sync all important dates.'
                        },
                        {
                            link: '/integrations/everhour',
                            icon: 'https://s3.us-east-2.amazonaws.com/cms.storage.startinfinity.com/production/integrations/integration/11/H3ViP35BNgzGThU1o2LhEUIdvsng9vYS6qeiYekm.png',
                            name: 'Everhour',
                            description: 'Use Everhour to track the time you spend on your tasks inside Infinity.'
                        }
                    ]
                },
            ],
            solutionsCategories: [
                {
                    name: 'Templates',
                    items: [
                        {
                            link: '/templates/simple-templates',
                            icon: '/img/home-v2/navbar-icons/templates/simple.svg',
                            name: 'Simple Templates',
                            description: 'Organize your work processes and tasks in a simple way.',
                            subitems: [
                                {
                                    link: '/templates/simple-kanban',
                                    icon: 'https://startinfinity.s3.us-east-2.amazonaws.com/production/templates/template/113/4yaO8FZvAp7MiJW2upcHy8rSZjo7cRlgiD1EcpOU.png',
                                    name: 'Simple Kanban',
                                },
                                {
                                    link: '/templates/simple-task-list',
                                    icon: 'https://startinfinity.s3.us-east-2.amazonaws.com/production/templates/template/114/NmTB0Y78uAlvvjQZBT0whr99xVNRZxTEXhTxzQG1.png',
                                    name: 'Simple Task List',
                                },
                                {
                                    link: '/templates/simple-calendar',
                                    icon: 'https://startinfinity.s3.us-east-2.amazonaws.com/production/templates/template/115/TtZW3zergod4YS3Cjx2qVlk6JwpPyfY14BoUPbTM.png',
                                    name: 'Simple Calendar',
                                },
                                {
                                    link: '/templates/simple-table',
                                    icon: 'https://startinfinity.s3.us-east-2.amazonaws.com/production/templates/template/116/Avd9b4vjZF0XkyqUFTQjOhal1MhyIBPyOpRfXxEu.png',
                                    name: 'Simple Table',
                                }
                            ]
                        },
                        {
                            link: '/templates/product-development',
                            icon: '/img/home-v2/navbar-icons/templates/product-development.svg',
                            name: 'Product Development',
                            description: 'Easily plan roadmaps, organize launches, and manage tasks.',
                            subitems: [
                                {
                                    link: '/templates/product-roadmap',
                                    icon: 'https://startinfinity.s3.us-east-2.amazonaws.com/production/templates/template/2/9XcxeHFzpK35bcgeE9wvFPMcr7fzgK7bwh8H9sr5.png',
                                    name: 'Product Roadmap',
                                },
                                {
                                    link: '/templates/product-management',
                                    icon: 'https://startinfinity.s3.us-east-2.amazonaws.com/production/templates/template/139/S9o0LuD1BAO2xKfpZhZg4d8sQjna4wRRkWOgQ5xO.png',
                                    name: 'Product Management',
                                },
                                {
                                    link: '/templates/growth-experiments',
                                    icon: 'https://startinfinity.s3.us-east-2.amazonaws.com/production/templates/template/103/D8HJfNQJ6mkYx5z1Qz2h5zKx6ywIpwOuqJbjpndN.png',
                                    name: 'Growth Experiments',
                                },
                                {
                                    link: '/templates/agile-development',
                                    icon: 'https://startinfinity.s3.us-east-2.amazonaws.com/production/templates/template/133/DRAUIzrD4ZIQhe4JCSYjV4qcvEXPCwVvDtAKNOdX.png',
                                    name: 'Agile Development',
                                }
                            ]
                        },
                        {
                            link: '/templates/project-management',
                            icon: '/img/home-v2/navbar-icons/templates/project-management.svg',
                            name: 'Project Management',
                            description: 'Plan, manage, and track all of your projects in a single place.',
                            subitems: [
                                {
                                    link: '/templates/project-management-template',
                                    icon: 'https://startinfinity.s3.us-east-2.amazonaws.com/production/templates/template/147/YZhs4fgoAnShxGbbgrQbRIecwOfHy7AuExaf5lhV.png',
                                    name: 'Project Management',
                                },
                                {
                                    link: '/templates/support-ticket-system',
                                    icon: 'https://startinfinity.s3.us-east-2.amazonaws.com/production/templates/template/139/S9o0LuD1BAO2xKfpZhZg4d8sQjna4wRRkWOgQ5xO.png',
                                    name: 'Support Ticket System',
                                },
                                {
                                    link: '/templates/client-work-management',
                                    icon: 'https://startinfinity.s3.us-east-2.amazonaws.com/production/templates/template/166/KWr8Vxg0GFgMSc6Sd2TQrAnYicCfVcaLYwxnJaxe.png',
                                    name: 'Client Work Management',
                                },
                                {
                                    link: '/templates/project-brainstorming',
                                    icon: 'https://startinfinity.s3.us-east-2.amazonaws.com/production/templates/template/172/NrWOLGCENotAmEMOfHNLC5uGyjcPq1MAGywKNyD1.png',
                                    name: 'Project Brainstorming',
                                }
                            ]
                        },
                        {
                            link: '/templates/marketing',
                            icon: '/img/home-v2/navbar-icons/templates/marketing.svg',
                            name: 'Marketing',
                            description: 'Manage campaigns, calendars, and different marketing tasks.',
                            subitems: [
                                {
                                    link: '/templates/client-sales-process',
                                    icon: 'https://startinfinity.s3.us-east-2.amazonaws.com/production/templates/template/149/93phzmWfnzq2CMBeVrdihzG451jV222sz8pNjhJE.png',
                                    name: 'Client Sales Process',
                                },
                                {
                                    link: '/templates/client-onboarding',
                                    icon: 'https://startinfinity.s3.us-east-2.amazonaws.com/production/templates/template/150/xQF8OQgQbIea2XSRGJ7bfk7UIQcjbEFUXK1q5UU6.png',
                                    name: 'Client Onboarding',
                                },
                                {
                                    link: '/templates/marketing-agency-client',
                                    icon: 'https://startinfinity.s3.us-east-2.amazonaws.com/production/templates/template/125/mZQgsXBHoENcmkZttGysrhfNmvYpGZiSakAtkuaW.png',
                                    name: 'Marketing Agency Client',
                                },
                                {
                                    link: '/templates/social-media-tracker',
                                    icon: 'https://startinfinity.s3.us-east-2.amazonaws.com/production/templates/template/123/BMFhu5N1CGxRG5M215t3Ro96cnLUduYSwkDbQiKC.png',
                                    name: 'Social Media Tracker',
                                }
                            ]
                        },
                        {
                            link: '/templates/events',
                            icon: '/img/home-v2/navbar-icons/templates/events.svg',
                            name: 'Events',
                            description: 'Never miss another meeting or an important event.',
                            subitems: [
                                {
                                    link: '/templates/meetings-calendar',
                                    icon: 'https://startinfinity.s3.us-east-2.amazonaws.com/production/templates/template/138/FPROl8AktjJAVFJeM2lPV7biMzyV1JL4I1PBo94F.png',
                                    name: 'Meetings Calendar',
                                },
                                {
                                    link: '/templates/event-planning',
                                    icon: 'https://startinfinity.s3.us-east-2.amazonaws.com/production/templates/template/109/lYVmofVaKhkHYHlnKdGercLXZN2wrlJ2z8k5EGeS.png',
                                    name: 'Event Planning',
                                },
                                {
                                    link: '/templates/meetup-organization',
                                    icon: 'https://startinfinity.s3.us-east-2.amazonaws.com/production/templates/template/110/XDPEU7uArHJGYpu0tmjmh1jegfcLGj3hP047UUpE.png',
                                    name: 'Meetup Organization',
                                }
                            ]
                        },
                        {
                            link: '/templates/hr',
                            icon: '/img/home-v2/navbar-icons/templates/hr.svg',
                            name: 'HR',
                            description: 'Keep an eye on your employees and job applicants.',
                            subitems: [
                                {
                                    link: '/templates/job-application',
                                    icon: 'https://startinfinity.s3.us-east-2.amazonaws.com/production/templates/template/153/TVLKetvc4ZTy9oT2l374X51ysOG2atH8QztgNjsQ.png',
                                    name: 'Job Application',
                                },
                                {
                                    link: '/templates/employee-database',
                                    icon: 'https://startinfinity.s3.us-east-2.amazonaws.com/production/templates/template/121/oVKxM1iH6h3MHguZ0OPMLGdVbRPCJecRmdCcN2gk.png',
                                    name: 'Employee Database',
                                },
                                {
                                    link: '/templates/employee-scheduling',
                                    icon: 'https://startinfinity.s3.us-east-2.amazonaws.com/production/templates/template/156/Zu8Bbsx0wQZbzOvmJsXEv6VCpVedboYgUGMdYPOS.png',
                                    name: 'Employee Scheduling',
                                },
                                {
                                    link: '/templates/employee-onboarding',
                                    icon: 'https://startinfinity.s3.us-east-2.amazonaws.com/production/templates/template/112/bQ4Z17LxMF3z3uVnT7lFdEO8GZYVRkTV36U33pVN.png',
                                    name: 'Employee Onboarding',
                                }
                            ]
                        },
                        {
                            link: '/templates/sales-templates',
                            icon: '/img/home-v2/navbar-icons/templates/sales.svg',
                            name: 'Sales',
                            description: 'Optimize your entire sales process without effort.',
                            subitems: [
                                {
                                    link: '/templates/sales-plan',
                                    icon: 'https://startinfinity.s3.us-east-2.amazonaws.com/production/templates/template/148/VeMEKFs398eddSUKp8E7luSwvMuoQwJHZED3qskh.png',
                                    name: 'Sales Plan',
                                },
                                {
                                    link: '/templates/client-sales-process',
                                    icon: 'https://startinfinity.s3.us-east-2.amazonaws.com/production/templates/template/149/93phzmWfnzq2CMBeVrdihzG451jV222sz8pNjhJE.png',
                                    name: 'Client Sales Process',
                                },
                                {
                                    link: '/templates/client-onboarding',
                                    icon: 'https://startinfinity.s3.us-east-2.amazonaws.com/production/templates/template/150/xQF8OQgQbIea2XSRGJ7bfk7UIQcjbEFUXK1q5UU6.png',
                                    name: 'Client Onboarding',
                                },
                                {
                                    link: '/templates/order-tracker',
                                    icon: 'https://startinfinity.s3.us-east-2.amazonaws.com/production/templates/template/122/fXQXUpJ5NRZN9lkq9qmMAlfwZ3drQpWDlacI7DjZ.png',
                                    name: 'Order Tracker',
                                }
                            ]
                        },
                        {
                            link: '/templates/freelance',
                            icon: '/img/home-v2/navbar-icons/templates/freelance.svg',
                            name: 'Freelance',
                            description: 'Keep your freelance business fully organized at all times.',
                            subitems: [
                                {
                                    link: '/templates/my-freelance-business',
                                    icon: 'https://startinfinity.s3.us-east-2.amazonaws.com/production/templates/template/137/YOJJjIzyRmrZnU7GnFyQ9pL4YmyowcYyr4dU2QPc.png',
                                    name: 'My Freelance Business',
                                },
                                {
                                    link: '/templates/tasks',
                                    icon: 'https://startinfinity.s3.us-east-2.amazonaws.com/production/templates/template/135/Hqik16b6hi70nzzO4xkM1LEfpMpUoYJFbluaJ2Zh.png',
                                    name: 'Tasks',
                                },
                                {
                                    link: '/templates/social-media-calendar',
                                    icon: 'https://startinfinity.s3.us-east-2.amazonaws.com/production/templates/template/119/Wh3hQCrw8y0ahVjTmNgXXTnBD8ttAGYHQpSrtQvj.png',
                                    name: 'Social Media Calendar',
                                },
                                {
                                    link: '/templates/meetings-calendar',
                                    icon: 'https://startinfinity.s3.us-east-2.amazonaws.com/production/templates/template/138/FPROl8AktjJAVFJeM2lPV7biMzyV1JL4I1PBo94F.png',
                                    name: 'Meetings Calendar',
                                }
                            ]
                        },
                        {
                            link: '/templates/personal',
                            icon: '/img/home-v2/navbar-icons/templates/personal.svg',
                            name: 'Personal',
                            description: 'Track habits, finances, goals, for the best personal results.',
                            subitems: [
                                {
                                    link: '/templates/personal-tasks',
                                    icon: 'https://startinfinity.s3.us-east-2.amazonaws.com/production/templates/template/126/LdL2jNcW10wd7vdjAIF9kN13RfZ8BXyalG09khd3.png',
                                    name: 'Personal Tasks',
                                },
                                {
                                    link: '/templates/personal-goals',
                                    icon: 'https://startinfinity.s3.us-east-2.amazonaws.com/production/templates/template/127/mZPsYmydw9ssgrzUlqkguWG4XA9OvvCXTmMPvp5v.png',
                                    name: 'Personal Goals',
                                },
                                {
                                    link: '/templates/habit-tracker',
                                    icon: 'https://startinfinity.s3.us-east-2.amazonaws.com/production/templates/template/128/ta61W7pqlYd8M8C7QUBortnSgiw4Pwk805MyISnB.png',
                                    name: 'Habit Tracker',
                                },
                                {
                                    link: '/templates/job-hunt',
                                    icon: 'https://startinfinity.s3.us-east-2.amazonaws.com/production/templates/template/129/EpdwUEfU1b7NUHBCrhJizjYuDj7kaywIg5mwW06F.png',
                                    name: 'Job Hunt',
                                }
                            ]
                        }
                    ]
                },
                {
                    name: 'Solutions',
                    items: [
                        { link: '/enterprise', icon: 'fa-buildings', className: 'enterprise-section', name: 'Enterprise', description: 'Organize your entire company, store important data, and collaborate with ease by using a single work management tool.' },
                        { link: '/infinity-echo', icon: 'fa-rocket-launch', className: 'echo-section', name: 'Infinity Echo', description: 'Launch your own branded software and templates with Infinity Echo. Completely customizable for your brand, clients and business model.' },
                        { link: '/unlimited-special-offer', icon: 'fa-tags', className: 'unlimited-section', name: 'Unlimited White Label', description: 'Don’t miss the opportunity to get unlimited members, unlimited boards, unlimited items, white label solution and all features.' },
                        { link: '/360-business-architect', icon: 'fa-briefcase', className: 'program-section', name: '360° Business Architect', description: 'Your Ultimate Business Management Framework, Course & Mentorship Hub' },
                        { link: '/360-growth-marketing-framework', icon: 'fa-chart-line-up', className: 'growth-section', name: '360° Growth Marketing', description: 'Scale Your Marketing Operations with Our Unique Growth and Marketing Framework' },
                    ]
                },
            ],
            resourcesCategories: [
                {
                    name: 'Use Cases',
                    items: [
                        { 
                            link: '/product-management-framework', 
                            icon: 'fa-duotone fa-bars-progress', 
                            name: 'Product Management', 
                            description: 'The Ultimate Product Management Framework to Help You Build Product.' 
                        },
                        { 
                            link: '/project-management', 
                            icon: 'fa-duotone fa-list-check', 
                            name: 'Project Management', 
                            description: 'Easily plan, manage, and collaborate on projects of all sizes.' 
                        },
                        { 
                            link: '/marketing-management-software', 
                            icon: 'fa-solid fa-megaphone', 
                            name: 'Marketing Management', 
                            description: 'Use Infinity to complete all of your marketing projects on time.' 
                        },
                        { 
                            link: '/client-management', 
                            icon: 'fa-duotone fa-users', 
                            name: 'Client Management', 
                            description: 'Close, Onboard, and Retain Clients with Well-Defined and Repeatable Processes.' 
                        },
                    ]
                },
                {
                    name: "Learn",
                    items: [
                        {
                            link: "/help",
                            icon: "fa-duotone fa-cloud-question",
                            name: "Help Center",
                            description: "Browse different help articles and learn to use Infinity better and faster."
                        },
                        {
                            link: "/help/1.0/getting-started/quick-guide-to-infinity",
                            icon: "fa-duotone fa-sign-post",
                            name: "Quick Guide",
                            description: "Jump into Infinity in a matter of minutes by going through our quick guide."
                        },
                        {
                            link: "https://www.youtube.com/watch?v=6GkbkotblE8",
                            icon: "fa-solid fa-circle-video",
                            name: "Video Tutorials",
                            description: "Watch basic and advanced video guides to become familiar with Infinity."
                        },
                        {
                            link: "/watch-webinar",
                            icon: "fa-duotone fa-play",
                            name: "Webinar",
                            description: "Watch basic and advanced video guides to become familiar with Infinity."
                        }
                    ]
                },
                {
                    name: "Discover",
                    items: [
                        {
                            link: "/blog",
                            icon: "fa-duotone fa-newspaper",
                            name: "Blog",
                            description: "Browse different help articles and learn to use Infinity better and faster."
                        },
                        {
                            link: "https://community.startinfinity.com/",
                            icon: "fa-duotone fa-comments",
                            name: "Forum",
                            description: "Join discussions with other Infinity members on our dedicated forum."
                        },
                        {
                            link: "/roadmap",
                            icon: "fa-duotone fa-arrow-progress",
                            name: "Roadmap",
                            description: "Stay up-to-date with upcoming features and functionalities with ease."
                        },
                        {
                            link: "/infinity-reviews",
                            icon: "fa-duotone fa-stars",
                            name: "Reviews",
                            description: "Stay up-to-date with upcoming features and functionalities with ease."
                        }
                    ]
                },
                {
                    name: "Services",
                    items: [
                        {
                            link: "/demo",
                            icon: "fa-duotone fa-headset",
                            name: "Schedule A Call",
                            description: "Get a detailed Infinity demo with one of our customer support agents."
                        },
                        {
                            link: "/professional-service",
                            icon: "fa-duotone fa-user-tie",
                            name: "Professional Service",
                            description: "Get a detailed Infinity demo with one of our customer support agents."
                        },
                        {
                            link: "/affiliate",
                            icon: "fa-duotone fa-handshake",
                            name: "Affiliates",
                            description: "Join Infinity’s partner program to start promoting Infinity for a commission."
                        }
                    ]
                }
            ]

        };
    },
    mounted() {
        if(this.productCategories && this.solutionsCategories) {
            this.selectedProductCategory = this.productCategories.find(category => category.name === 'Features');
            this.selectedSolutionsCategory = this.solutionsCategories.find(category => category.name === 'Templates');
        }
    },
    methods: {
        selectProductCategory(category) {
            this.selectedProductCategory = category;
        },
        selectSolutionsCategory(category) {
            this.selectedSolutionsCategory = category;
        }
    },
};
</script>



// WEBPACK FOOTER //
// resources/js/frontend/components/MegaNav.vue